import { isClientError } from '@/libs/utilities/CustomErrors'
import { captureException } from '@sentry/vue'
import { h } from 'vue'
import { trackRouter } from 'vue-gtag-next'
import { createRouter, createWebHistory, RouterView } from 'vue-router'

import { bindStringDictionary, getQuery } from '@/libs/utilities/getQuery'

import * as layouts from '@/layouts'
import { store } from '@/store'

import * as logger from '@/logger/logger'

import AdminNewsDetail from '@/pages/AdminNewsDetailPage/AdminNewsDetailPage.vue'
import AdminNewsList from '@/pages/AdminNewsListPage/AdminNewsListPage.vue'
import ChatPageContainer from '@/pages/ChatPage/ChatPageContainer.vue'
import ChatPageMemberView from '@/pages/ChatPage/ChatPageMemberView/ChatPageMemberView.vue'
import ChatPageOwnView from '@/pages/ChatPage/ChatPageOwnView/ChatPageOwnView.vue'
import DashboardPage from '@/pages/DashboardPage/DashboardPage.vue'
import TermPage from '@/pages/TermPage/TermPage.vue'

import AttackListSenderSettingCsvPage from '@/pages/AttackListSenderSettingCsvPage/AttackListSenderSettingCsvPage.vue'
import {
  ErrorBadRequest,
  ErrorPageForbidden,
  ErrorPageInternalServerError,
  ErrorPageNotFound,
} from '@/pages/ErrorPage'
import ChatMessageSendingJobIndexPage from '@/pages/ChatMessageSendingJobIndexPage/ChatMessageSendingJobIndexPage.vue'
import ChatMessageSendingJobDetailPage from '@/pages/ChatMessageSendingJobDetailPage/ChatMessageSendingJobDetailPage.vue'
import ChatMessageSendingJobNewPage from '@/pages/ChatMessageSendingJobNewPage/ChatMessageSendingJobNewPage.vue'
import KarteListPage from '@/pages/KarteListPage/KarteListPage.vue'
import LoginPage from '@/pages/LoginPage/LoginPage.vue'
import MembersReportPage from '@/pages/MembersReportPage/MembersReportPage.vue'
import PasswordResetChange from '@/pages/PasswordResetPage/PasswordResetChangePage.vue'
import PasswordResetRequest from '@/pages/PasswordResetPage/PasswordResetRequestPage.vue'
import SeminarListPage from '@/pages/SeminarListPage/SeminarListPage.vue'
import SettingsPage from '@/pages/SettingsPage/SettingsPage.vue'
import SettingsPageAuthzPolicyView from '@/pages/SettingsPage/SettingsPageAuthzPolicyView/SettingsPageAuthzPolicyView.vue'
import SettingsPageAuthzPolicyDetailView from '@/pages/SettingsPage/SettingsPageAuthzPolicyView/SettingsPageAuthzPolicyDetailView.vue'
import SettingsPageAuthzPolicyCreateView from '@/pages/SettingsPage/SettingsPageAuthzPolicyView/SettingsPageAuthzPolicyCreateView.vue'
import SettingsPageAuthzPolicyEditView from '@/pages/SettingsPage/SettingsPageAuthzPolicyView/SettingsPageAuthzPolicyEditView.vue'
import SettingsPageAccountView from '@/pages/SettingsPage/SettingsPageAccountView/SettingsPageAccountView.vue'
import SettingsPageAttackListSenderCreateView from '@/pages/SettingsPage/SettingsPageAttackListSenderView/SettingsPageAttackListSenderCreateView.vue'
import SettingsPageAttackListSenderUpdateView from '@/pages/SettingsPage/SettingsPageAttackListSenderView/SettingsPageAttackListSenderUpdateView.vue'
import SettingsPageAttackListSenderView from '@/pages/SettingsPage/SettingsPageAttackListSenderView/SettingsPageAttackListSenderView.vue'
import SettingsPageAutoChatReplyCopyView from '@/pages/SettingsPage/SettingsPageAutoChatReplyView/SettingsPageAutoChatReplyCopyView.vue'
import SettingsPageAutoChatReplyCreateView from '@/pages/SettingsPage/SettingsPageAutoChatReplyView/SettingsPageAutoChatReplyCreateView.vue'
import SettingsPageAutoChatReplyDetailView from '@/pages/SettingsPage/SettingsPageAutoChatReplyView/SettingsPageAutoChatReplyDetailView.vue'
import SettingsPageAutoChatReplyView from '@/pages/SettingsPage/SettingsPageAutoChatReplyView/SettingsPageAutoChatReplyView.vue'
import SettingsPageAutoChatReplyEditViewForNormalMessage from '@/pages/SettingsPage/SettingsPageAutoChatReplyView/SettingsPageAutoChatReplyEditViewForNormalMessage.vue'
import SettingsPageAutoPostKartePlannerCommentViewFetcher from '@/pages/SettingsPage/SettingsPageAutoPostKartePlannerCommentView/SettingsPageAutoPostKartePlannerCommentViewFetcher.vue'
import SettingsPageCalendarAuthCallbackView from '@/pages/SettingsPage/SettingsPageCalendarAuthCallbackView/SettingsPageCalendarAuthCallbackView.vue'
import SettingsPageCalendarView from '@/pages/SettingsPage/SettingsPageCalendarView/SettingsPageCalendarView.vue'
import SettingsPageCalendarCreateView from '@/pages/SettingsPage/SettingsPageCalendarView/SettingsPageCalendarCreateView.vue'
import SettingsPageCalendarDetailView from '@/pages/SettingsPage/SettingsPageCalendarView/SettingsPageCalendarDetailView.vue'
import SettingsPageCalendarBookingView from '@/pages/SettingsPage/SettingsPageCalendarView/SettingsPageCalendarBookingView.vue'
import SettingsPageContractViewFetcher from '@/pages/SettingsPage/SettingsPageContractView/SettingsPageContractViewFetcher.vue'
import SettingsPageCorporationView from '@/pages/SettingsPage/SettingsPageCorporationView/SettingsPageCorporationView.vue'
import SettingsPageIntroductionMessageView from '@/pages/SettingsPage/SettingsPageIntroductionMessageView/SettingsPageIntroductionMessageView.vue'
import SettingsPageIntroductionMessageConditionalCreateView from '@/pages/SettingsPage/SettingsPageIntroductionMessageView/SettingsPageIntroductionMessageConditionalCreateView.vue'
import SettingsPageIntroductionMessageConditionalEditView from '@/pages/SettingsPage/SettingsPageIntroductionMessageView/SettingsPageIntroductionMessageConditionalEditView.vue'
import SettingsPageLineActivationInflowSourceCreateView from '@/pages/SettingsPage/SettingsPageLineActivationInflowSourceView/SettingsPageLineActivationInflowSourceCreateView.vue'
import SettingsPageLineActivationInflowSourceEditView from '@/pages/SettingsPage/SettingsPageLineActivationInflowSourceView/SettingsPageLineActivationInflowSourceEditView.vue'
import SettingsPageLineActivationInflowSourceView from '@/pages/SettingsPage/SettingsPageLineActivationInflowSourceView/SettingsPageLineActivationInflowSourceView.vue'
import SettingsPageLineActivationManagerViewOkanekoId from '@/pages/SettingsPage/SettingsPageLineActivationManagerView/OkanekoId.vue'
import SettingsPageLineActivationManagerViewSelfGenerationId from '@/pages/SettingsPage/SettingsPageLineActivationManagerView/SelfGenerationId.vue'
import SettingsPageLineActivationManagerView from '@/pages/SettingsPage/SettingsPageLineActivationManagerView/SettingsPageLineActivationManagerView.vue'
import SettingsPageLineActivationUserVariableCreateView from '@/pages/SettingsPage/SettingsPageLineActivationUserVariableCreateView/SettingsPageLineActivationUserVariableCreateView.vue'
import SettingsPageLineActivationUserVariableEditView from '@/pages/SettingsPage/SettingsPageLineActivationUserVariableEditView/SettingsPageLineActivationUserVariableEditView.vue'
import SettingsPageLineActivationUserVariableListView from '@/pages/SettingsPage/SettingsPageLineActivationUserVariableListView/SettingsPageLineActivationUserVariableListView.vue'
import SettingsPageMemberManagementCreateView from '@/pages/SettingsPage/SettingsPageMemberManagementView/SettingsPageMemberManagementCreateView.vue'
import SettingsPageMemberManagementDetailView from '@/pages/SettingsPage/SettingsPageMemberManagementView/SettingsPageMemberManagementDetailView.vue'
import SettingsPageMemberManagementUpdateView from '@/pages/SettingsPage/SettingsPageMemberManagementView/SettingsPageMemberManagementUpdateView.vue'
import SettingsPageMemberManagementView from '@/pages/SettingsPage/SettingsPageMemberManagementView/SettingsPageMemberManagementView.vue'
import SettingsPageTeamManagementView from '@/pages/SettingsPage/SettingsPageTeamManagementView/SettingsPageTeamManagementView.vue'
import SettingsPageTeamManagementDetailView from '@/pages/SettingsPage/SettingsPageTeamManagementView/SettingsPageTeamManagementDetailView.vue'
import SettingsPageTeamManagementUpdateView from '@/pages/SettingsPage/SettingsPageTeamManagementView/SettingsPageTeamManagementUpdateView.vue'
import SettingsPagePlannerViewFetcher from '@/pages/SettingsPage/SettingsPagePlannerView/SettingsPagePlannerViewFetcher.vue'
import SettingsPageUsageView from '@/pages/SettingsPage/SettingsPageUsageView/SettingsPageUsageView.vue'
import SettingsPageSwitchEntranceView from '@/pages/SettingsPage/SettingsPageSwitchEntranceView/SettingsPageSwitchEntranceView.vue'
import SettingsStripeCallbackPage from '@/pages/SettingsPage/SettingsStripeCallbackPage.vue'
import SolicitorCloudPageDocumentCoverageSearchView from '@/pages/SolicitorCloudPage/DocumentView/CoverageSearchView.vue'
import SolicitorCloudPageDocumentCoverageView from '@/pages/SolicitorCloudPage/DocumentView/CoverageView.vue'
import SolicitorCloudPageDocumentPamphletView from '@/pages/SolicitorCloudPage/DocumentView/PamphletView.vue'
import SolicitorCloudPageDocumentSalesMaterialView from '@/pages/SolicitorCloudPage/DocumentView/SalesMaterialView.vue'
import SolicitorCloudPage from '@/pages/SolicitorCloudPage/SolicitorCloudPage.vue'

import LineActivationProviderSettingEditPage from '@/pages/LineActivationProviderSettingEditPage/LineActivationProviderSettingEditPage.vue'

import LineRichMenuEditPage from '@/pages/LineRichMenuEditPage/LineRichMenuEditPage.vue'
import LineRichMenuIndexPage from '@/pages/LineRichMenuIndexPage/LineRichMenuIndexPage.vue'
import LineRichMenuNewPage from '@/pages/LineRichMenuNewPage/LineRichMenuNewPage.vue'

import EnqueteEditPage from '@/pages/EnqueteEditPage/EnqueteEditPage.vue'
import EnqueteIndexPage from '@/pages/EnqueteIndexPage/EnqueteIndexPage.vue'
import EnqueteNewPage from '@/pages/EnqueteNewPage/EnqueteNewPage.vue'

import ChatRedirector from '@/pages/ChatPage/ChatRedirector.vue'

import StepDeliveryEditPage from '@/pages/StepDeliveryEditPage/StepDeliveryEditPage.vue'
import StepDeliveryIndexPage from '@/pages/StepDeliveryIndexPage/StepDeliveryIndexPage.vue'
import StepDeliveryNewPage from '@/pages/StepDeliveryNewPage/StepDeliveryNewPage.vue'

import SettingsPageChatMessageTemplateView from '@/pages/SettingsPage/SettingsPageChatMessageTemplateView/SettingsPageChatMessageTemplateView.vue'
import SettingsPageChatMessageTemplateCreateView from '@/pages/SettingsPage/SettingsPageChatMessageTemplateView/SettingsPageChatMessageTemplateCreateView.vue'
import SettingsPageChatMessageTemplateDetailView from '@/pages/SettingsPage/SettingsPageChatMessageTemplateView/SettingsPageChatMessageTemplateDetailView.vue'

import SettingsPageScenarioChatIndexView from '@/pages/SettingsPage/SettingsPageScenarioChatIndexView/ScenarioChatIndexPage.vue'
import ScenarioChatPage from '@/pages/ScenarioChatPage/ScenarioChatPage.vue'
import ScenarioChatNewPage from '@/pages/ScenarioChatNewPage/ScenarioChatNewPage.vue'

import OkaneKollegeIndexPage from './pages/OkaneKollegeIndexPage/OkaneKollegeIndexPage.vue'
import OkaneKollegeUserPage from './pages/OkaneKollegeUserPage/OkaneKollegeUserPage.vue'
import OkaneKollegeDailyLessonView from './pages/OkaneKollegeUserPage/views/DailyLessonView.vue'
import OkaneKollegeUserCourseLessonView from './pages/OkaneKollegeUserPage/views/UserCourseLessonView.vue'
import OkaneKollegeUserCourseView from './pages/OkaneKollegeUserPage/views/UserCourseView.vue'
import OkaneKollegeUserTrialView from './pages/OkaneKollegeUserPage/views/TrialView.vue'
import OkaneKollegeUserEditProfileView from './pages/OkaneKollegeUserPage/views/EditProfileView.vue'
import OkaneKollegeUserCourseCancelView from './pages/OkaneKollegeUserPage/views/UserCourseCancelView.vue'
import OkaneKollegeUserPaymentView from './pages/OkaneKollegeUserPage/views/PaymentView.vue'

import EntranceBookingsPage from './pages/EntranceBookingsPage/EntranceBookingsPage.vue'

import type {
  LocationQuery,
  LocationQueryRaw,
  NavigationGuard,
  RouteLocationNormalized,
  RouteRecordNormalized,
  RouteRecordRaw,
} from 'vue-router'
import EntranceGUIDRedirectPage from './pages/RedirectPage/EntranceGUIDRedirectPage.vue'

const chatRouteMeta: RouteRecordRaw['meta'] = {
  requiresAuth: true,
  breadcrumbs: [{ to: { name: 'chat' }, text: 'チャット' }],
}

const settingsRouteMeta: RouteRecordRaw['meta'] = {
  requiresAuth: true,
  layout: {
    component: layouts.wide,
  },
}

const karteRouteMeta: RouteRecordRaw['meta'] = {
  requiresAuth: true,
  layout: {
    component: layouts._default,
    props: {
      footerSize: 'small',
    },
  },
  breadcrumbs: [{ to: { name: 'karteList' }, text: 'ユーザーを探す' }],
}

const logoutNavigationGuard: NavigationGuard = async (_to, _from, next) => {
  try {
    await store.dispatch('logout')
    next()
  } catch (e) {
    if (!isClientError(e)) {
      captureException(e)
    }
    next({ name: 'errorInternalServerError' })
  }
}

const ROOT_PATH = '/'

const errorPageNavigationGuard =
  (statusCode: number): NavigationGuard =>
  async (to, from, next) => {
    const url = new URL(to.fullPath, window.location.origin).toString()
    await logger.ltlPeople.page.error(logger.buildMeta(store, { url }), {
      route: {
        path: from.fullPath,
        statusCode: statusCode.toString(),
      },
    })
    next()
  }

export const routes: RouteRecordRaw[] = [
  // 認証が必要なページ
  {
    path: '/e/:entranceGUID',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: {
          layout: {
            component: layouts._default,
          },
          render: () => h(DashboardPage),
        },
        meta: {
          requiresAuth: true,
        },
      },
      // シナリオチャット index ページは 設定 の中にある
      {
        name: 'scenarioChatNew',
        path: 'scenario-chat/new',
        component: ScenarioChatNewPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts.fullBleed,
            props: {
              footerSize: 'small',
            },
          },
        },
      },
      {
        name: 'scenarioChatEdit',
        path: 'scenario-chat/:guid',
        component: ScenarioChatPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts.fullBleed,
            props: {
              footerSize: 'small',
            },
          },
        },
      },
      {
        name: 'stripeCallback',
        path: 'stripe_callback',
        component: SettingsStripeCallbackPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts.guest,
          },
        },
      },
      {
        path: 'skillforce',
        component: SolicitorCloudPage,
        children: [
          {
            name: 'solicitorCloudDocumentsPamphlet',
            path: 'documents/pamphlet',
            component: SolicitorCloudPageDocumentPamphletView,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'solicitorCloudDocumentsSalesMaterial',
            path: 'documents/sales-material',
            component: SolicitorCloudPageDocumentSalesMaterialView,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'solicitorCloudDocumentsCoverage',
            path: 'documents/conditions',
            component: SolicitorCloudPageDocumentCoverageView,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            path: '',
            name: 'solicitorCloud',
            component: SolicitorCloudPageDocumentCoverageSearchView,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
        ],
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
        },
      },
      {
        path: 'enquete',
        component: { render: () => h(RouterView) },
        children: [
          {
            name: 'EnqueteIndexPage',
            path: '',
            component: EnqueteIndexPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'EnqueteNewPage',
            path: 'new',
            component: EnqueteNewPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'EnqueteEditPage',
            path: ':enqueteGUID',
            component: EnqueteEditPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
        ],
      },
      {
        path: 'step-delivery',
        component: { render: () => h(RouterView) },
        children: [
          {
            name: 'StepDeliveryIndexPage',
            path: '',
            component: StepDeliveryIndexPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'StepDeliveryNewPage',
            path: 'new',
            component: StepDeliveryNewPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'StepDeliveryEditPage',
            path: ':stepDeliveryGUID',
            component: StepDeliveryEditPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
        ],
      },
      {
        path: 'settings',
        component: SettingsPage,
        children: [
          {
            name: 'plannerSettings',
            path: 'profile',
            component: SettingsPagePlannerViewFetcher,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'plannerSettings' }, text: 'プロフィール' },
              ],
            },
            children: [
              {
                name: 'plannerSettingsEditing',
                path: 'edit',
                component: SettingsPagePlannerViewFetcher,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'plannerSettings' }, text: 'プロフィール' },
                    { to: { name: 'plannerSettingsEditing' }, text: '編集' },
                  ],
                },
              },
            ],
          },
          {
            name: 'corporationSettings',
            path: 'corporation',
            component: SettingsPageCorporationView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'corporationSettings' }, text: '会社情報' },
              ],
            },
          },
          {
            name: 'accountSettings',
            path: 'account',
            component: SettingsPageAccountView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'accountSettings' }, text: 'アカウント' },
              ],
            },
            children: [
              {
                name: 'accountSettingsPasswordEditing',
                path: 'password/edit',
                component: SettingsPageAccountView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                    {
                      to: { name: 'accountSettingsPasswordEditing' },
                      text: '編集',
                    },
                  ],
                },
              },
              {
                name: 'accountSettingsProfileEditing',
                path: 'profile/edit',
                component: SettingsPageAccountView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                    {
                      to: { name: 'accountSettingsProfileEditing' },
                      text: '編集',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'member-management',
            component: RouterView,
            children: [
              {
                name: 'memberManagementSetting',
                path: '',
                component: SettingsPageMemberManagementView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'memberManagementSetting' },
                      text: 'メンバー管理',
                    },
                  ],
                },
              },
              {
                name: 'memberManagementSettingNew',
                path: 'new',
                component: SettingsPageMemberManagementCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'memberManagementSetting' },
                      text: 'メンバー管理',
                    },
                    {
                      to: { name: 'memberManagementSettingNew' },
                      text: 'メンバー追加',
                    },
                  ],
                },
              },
              {
                name: 'memberManagementSettingDetail',
                path: ':memberManagementSettingId(\\S+)',
                component: SettingsPageMemberManagementDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'memberManagementSetting' },
                      text: 'メンバー管理',
                    },
                    {
                      to: { name: 'memberManagementSettingDetail' },
                      text: 'メンバー詳細',
                    },
                  ],
                },
              },
              {
                name: 'memberManagementSettingEdit',
                path: ':memberManagementSettingId(\\S+)/edit',
                component: SettingsPageMemberManagementUpdateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'memberManagementSetting' },
                      text: 'メンバー管理',
                    },
                    {
                      to: { name: 'memberManagementSettingEdit' },
                      text: 'メンバー編集',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'team-management',
            component: RouterView,
            children: [
              {
                name: 'teamManagementSetting',
                path: '',
                component: SettingsPageTeamManagementView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'teamManagementSetting' },
                      text: 'チーム管理',
                    },
                  ],
                },
              },
              {
                name: 'teamManagementSettingDetail',
                path: ':teamManagementSettingId(\\S+)',
                component: SettingsPageTeamManagementDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'teamManagementSetting' },
                      text: 'チーム管理',
                    },
                    {
                      to: { name: 'teamManagementSettingDetail' },
                      text: 'チーム詳細',
                    },
                  ],
                },
              },
              {
                name: 'teamManagementSettingEdit',
                path: ':teamManagementSettingId(\\S+)/edit',
                component: SettingsPageTeamManagementUpdateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'teamManagementSetting' },
                      text: 'チーム管理',
                    },
                    {
                      to: { name: 'teamManagementSettingDetail' },
                      text: 'チーム詳細',
                    },
                  ],
                },
              },
            ],
          },
          {
            name: 'usageSettings',
            path: 'usage',
            component: SettingsPageUsageView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'usageSettings' }, text: 'アカウント' },
              ],
            },
          },
          {
            path: 'calendar',
            component: RouterView,
            children: [
              {
                name: 'calendarSetting',
                path: '',
                component: SettingsPageCalendarView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'calendarSetting' }, text: 'カレンダー' },
                  ],
                },
              },
              {
                name: 'calendarSettingCreate',
                path: 'new',
                component: SettingsPageCalendarCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'calendarSetting' }, text: 'カレンダー' },
                    {
                      to: { name: 'calendarSettingCreate' },
                      text: 'カレンダーを作成',
                    },
                  ],
                },
              },
              {
                name: 'calendarSettingDetail',
                path: ':calendarGUID',
                component: SettingsPageCalendarDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'calendarSetting' }, text: 'カレンダー' },
                    {
                      to: { name: 'calendarSettingDetail' },
                      text: 'カレンダー詳細',
                    },
                  ],
                },
              },
              {
                name: 'calendarSettingBooking',
                path: 'booking/:bookingGUID',
                component: SettingsPageCalendarBookingView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'calendarSetting' }, text: 'カレンダー' },
                    {
                      to: { name: 'calendarSettingBooking' },
                      text: '予約詳細',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'login-activation',
            component: SettingsPageLineActivationManagerView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'accountSettings' }, text: 'アカウント' },
              ],
            },
            children: [
              {
                name: 'lineActivationSettingSelfGenerationId',
                path: 'self-generation-id',
                component:
                  SettingsPageLineActivationManagerViewSelfGenerationId,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                  ],
                },
              },
              {
                name: 'lineActivationSettingOkanekoId',
                path: 'okaneko-id',
                component: SettingsPageLineActivationManagerViewOkanekoId,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                  ],
                },
              },
              {
                path: '',
                name: 'lineActivationSetting',
                redirect: { name: 'lineActivationSettingSelfGenerationId' },
              },
            ],
          },
          {
            path: 'inflow-source',
            component: RouterView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'accountSettings' }, text: 'アカウント' },
              ],
            },
            children: [
              {
                name: 'LineActivationSettingInflowSource',
                path: '',
                component: SettingsPageLineActivationInflowSourceView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                  ],
                },
              },
              {
                name: 'LineActivationSettingInflowSourceCreate',
                path: 'new',
                component: SettingsPageLineActivationInflowSourceCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                  ],
                },
              },
              {
                name: 'LineActivationSettingInflowSourceEdit',
                path: ':inflowSourceId',
                component: SettingsPageLineActivationInflowSourceEditView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    { to: { name: 'accountSettings' }, text: 'アカウント' },
                  ],
                },
              },
            ],
          },
          {
            path: 'user-variables',
            component: RouterView,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [{ to: { name: 'settings' }, text: '設定' }],
            },
            children: [
              {
                name: 'LineActivationSettingUserVariableListView',
                path: '',
                component: SettingsPageLineActivationUserVariableListView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [{ to: { name: 'settings' }, text: '設定' }],
                },
              },
              {
                name: 'LineActivationSettingUserVariableCreateView',
                path: 'new',
                component: SettingsPageLineActivationUserVariableCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'LineActivationSettingUserVariableListView' },
                      text: 'カスタム項目',
                    },
                  ],
                },
              },
              {
                name: 'LineActivationSettingUserVariableEditView',
                path: ':userVariableGuid',
                component: SettingsPageLineActivationUserVariableEditView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'LineActivationSettingUserVariableListView' },
                      text: 'カスタム項目',
                    },
                  ],
                },
              },
            ],
          },
          {
            name: 'contractSettings',
            path: 'contract',
            component: SettingsPageContractViewFetcher,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                { to: { name: 'contractSettings' }, text: '請求先情報' },
              ],
            },
          },
          {
            name: 'autoPostKartePlannerComment',
            path: 'auto-post-karte-planner-comment',
            component: SettingsPageAutoPostKartePlannerCommentViewFetcher,
            meta: {
              ...settingsRouteMeta,
              breadcrumbs: [
                { to: { name: 'settings' }, text: '設定' },
                {
                  to: { name: 'autoPostKartePlannerComment' },
                  text: '自動アプローチ',
                },
              ],
            },
          },
          {
            path: 'auto-chat-reply',
            component: RouterView,
            children: [
              {
                name: 'autoChatReplySetting',
                path: '',
                component: SettingsPageAutoChatReplyView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'autoChatReplySetting' },
                      text: '自動応答チャットメッセージ',
                    },
                  ],
                },
              },
              {
                name: 'autoChatReplySettingNew',
                path: 'new',
                component: SettingsPageAutoChatReplyCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'autoChatReplySetting' },
                      text: '自動応答チャットメッセージ',
                    },
                    {
                      to: { name: 'autoChatReplySettingNew' },
                      text: '新しい条件を作成',
                    },
                  ],
                },
              },
              {
                name: 'autoChatReplySettingDetail',
                path: ':autoChatReplySettingId(\\d+)',
                component: SettingsPageAutoChatReplyDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'autoChatReplySetting' },
                      text: '自動応答チャットメッセージ',
                    },
                    {
                      to: { name: 'autoChatReplySettingDetail' },
                      text: '条件の編集',
                    },
                  ],
                },
              },
              {
                name: 'autoChatReplySettingCopy',
                path: 'copy',
                component: SettingsPageAutoChatReplyCopyView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'autoChatReplySetting' },
                      text: '自動応答チャットメッセージ',
                    },
                    {
                      to: { name: 'autoChatReplySettingCopy' },
                      text: '自動応答チャットメッセージの複製',
                    },
                  ],
                },
              },
              {
                name: 'normalMessageChatReplySettingEdit',
                path: 'edit-for-normalmessage',
                component: SettingsPageAutoChatReplyEditViewForNormalMessage,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'autoChatReplySetting' },
                      text: '自動応答チャットメッセージ',
                    },
                    {
                      to: { name: 'normalMessageChatReplySettingEdit' },
                      text: '編集',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'scenario-chat',
            component: RouterView,
            children: [
              {
                name: 'scenarioChatIndex',
                path: '',
                component: SettingsPageScenarioChatIndexView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'scenarioChatIndex' },
                      text: 'シナリオチャット',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'chat-message-template',
            component: RouterView,
            children: [
              {
                name: 'chatMessageTemplate',
                path: '',
                component: SettingsPageChatMessageTemplateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'chatMessageTemplate' },
                      text: 'テンプレート',
                    },
                  ],
                },
              },
              {
                name: 'chatMessageTemplateNew',
                path: 'new',
                component: SettingsPageChatMessageTemplateCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'chatMessageTemplate' },
                      text: 'テンプレート',
                    },
                    {
                      to: { name: 'chatMessageTemplateNew' },
                      text: '新しいテンプレートを作成',
                    },
                  ],
                },
              },
              {
                name: 'chatMessageTemplateDetail',
                path: ':chatMessageTemplateGuid(\\S+)',
                component: SettingsPageChatMessageTemplateDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'chatMessageTemplate' },
                      text: 'テンプレート',
                    },
                    {
                      to: { name: 'chatMessageTemplateDetail' },
                      text: 'テンプレートの編集',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'introduction-message',
            component: RouterView,
            children: [
              {
                name: 'introductionMessageSetting',
                path: '',
                component: SettingsPageIntroductionMessageView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'introductionMessageSetting' },
                      text: '初期チャットメッセージ',
                    },
                  ],
                },
              },
              {
                name: 'introductionMessageSettingConditionalCreate',
                path: 'conditional-create',
                component: SettingsPageIntroductionMessageConditionalCreateView,
                meta: {
                  ...settingsRouteMeta,
                },
              },
              {
                name: 'introductionMessageSettingConditionalEdit',
                path: ':conditionalGUID',
                component: SettingsPageIntroductionMessageConditionalEditView,
                meta: {
                  ...settingsRouteMeta,
                },
              },
            ],
          },
          {
            path: 'attack-list-sender',
            component: RouterView,
            children: [
              {
                name: 'attackListSenderSetting',
                path: '',
                component: SettingsPageAttackListSenderView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'attackListSenderSetting' },
                      text: 'アプローチ自動代行',
                    },
                  ],
                },
              },
              {
                name: 'attackListSenderSettingNew',
                path: 'new',
                component: SettingsPageAttackListSenderCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'attackListSenderSetting' },
                      text: 'アプローチ自動代行',
                    },
                    {
                      to: { name: 'attackListSenderSettingNew' },
                      text: '新しい条件を作成',
                    },
                  ],
                },
              },
              {
                name: 'attackListSenderSettingUpdate',
                path: ':attackListSenderSettingId(\\d+)',
                component: SettingsPageAttackListSenderUpdateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'attackListSenderSetting' },
                      text: 'アプローチ自動代行',
                    },
                    {
                      to: { name: 'attackListSenderSettingUpdate' },
                      text: '条件の編集',
                    },
                  ],
                },
              },
            ],
          },
          {
            path: 'authz-policy',
            component: RouterView,
            children: [
              {
                name: 'authzPolicySetting',
                path: '',
                component: SettingsPageAuthzPolicyView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [{ to: { name: 'settings' }, text: '設定' }],
                },
              },
              {
                name: 'authzPolicySettingNew',
                path: 'new',
                component: SettingsPageAuthzPolicyCreateView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'authzPolicySetting' },
                      text: 'アクセスコントロール',
                    },
                  ],
                },
              },
              {
                name: 'authzPolicySettingDetail',
                path: ':authzPolicySettingGuid',
                component: SettingsPageAuthzPolicyDetailView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'authzPolicySetting' },
                      text: 'アクセスコントロール',
                    },
                  ],
                },
              },
              {
                name: 'authzPolicySettingEdit',
                path: 'edit/:authzPolicySettingGuid',
                component: SettingsPageAuthzPolicyEditView,
                meta: {
                  ...settingsRouteMeta,
                  breadcrumbs: [
                    { to: { name: 'settings' }, text: '設定' },
                    {
                      to: { name: 'authzPolicySetting' },
                      text: 'アクセスコントロール',
                    },
                  ],
                },
              },
            ],
          },
          {
            name: 'switchEntrance',
            path: 'switch-entrance',
            component: SettingsPageSwitchEntranceView,
            meta: {
              ...settingsRouteMeta,
            },
          },
          {
            path: '',
            name: 'settings',
            redirect: { name: 'plannerSettings' },
          },
        ],
      },
      {
        path: 'bookings',
        name: 'EntranceBookingsPage',
        component: EntranceBookingsPage,
        meta: {
          requiresAuth: true,
          layout: { component: layouts.wide },
          breadcrumbs: [],
        },
      },
      {
        path: 'report',
        component: { render: () => h(RouterView) },
        children: [
          {
            path: 'members',
            name: 'membersReport',
            component: MembersReportPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
              breadcrumbs: [
                { to: { name: 'membersReport' }, text: '社内レポート' },
              ],
            },
          },
          {
            path: '',
            name: 'reportIndex',
            redirect: { name: 'membersReport' },
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
              breadcrumbs: [
                { to: { name: 'membersReport' }, text: '社内レポート' },
              ],
            },
          },
        ],
      },
      {
        path: 'news',
        component: { render: () => h(RouterView) },
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
          breadcrumbs: [{ to: { name: 'news' }, text: 'お知らせ' }],
        },
        children: [
          {
            path: ':newsId(\\d+)',
            name: 'newsDetail',
            component: AdminNewsDetail,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
              breadcrumbs: [{ to: { name: 'news' }, text: 'お知らせ' }],
            },
          },
          {
            path: '',
            name: 'news',
            component: AdminNewsList,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
              breadcrumbs: [{ to: { name: 'news' }, text: 'お知らせ' }],
            },
          },
        ],
      },
      {
        path: 'chat',
        component: RouterView,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
        },
        children: [
          {
            path: '',
            // 親の path: '/chat' に対して name 指定で遷移すると、この path: '' にマッチしてくれないので、
            // name: 'chat' は実質ルートであるこのコンポーネントに指定する
            name: 'chat',
            component: ChatRedirector,
          },
          {
            path: 'members',
            meta: chatRouteMeta,
            component: {
              layout: {
                component: layouts.fullBleed,
                props: {
                  footerSize: 'small',
                },
              },
              render: () => h(ChatPageContainer),
            },
            children: [
              {
                path: ':roomId(\\d+)',
                name: 'memberChat',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(ChatPageMemberView),
                },
              },
              {
                path: '',
                name: 'memberChatIndex',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(RouterView),
                },
              },
            ],
          },
          {
            path: 'own',
            component: {
              layout: {
                component: layouts.fullBleed,
                props: {
                  footerSize: 'small',
                },
              },
              render: () => h(ChatPageContainer),
            },
            meta: chatRouteMeta,
            children: [
              {
                path: ':roomId(\\d+)',
                name: 'ownChat',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(ChatPageOwnView),
                },
              },
              {
                path: '',
                name: 'ownChatIndex',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(RouterView),
                },
              },
            ],
          },
          {
            path: 'assigned',
            component: {
              layout: {
                component: layouts.fullBleed,
                props: {
                  footerSize: 'small',
                },
              },
              render: () => h(ChatPageContainer),
            },
            meta: chatRouteMeta,
            children: [
              {
                path: ':roomId(\\d+)',
                name: 'assignedChat',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(ChatPageOwnView),
                },
              },
              {
                path: '',
                name: 'assignedChatIndex',
                component: {
                  layout: {
                    component: layouts.fullBleed,
                    props: {
                      footerSize: 'small',
                    },
                  },
                  render: () => h(RouterView),
                },
              },
            ],
          },
        ],
      },
      {
        path: 'karte',
        name: 'karteList',
        component: KarteListPage,
        meta: karteRouteMeta,
        children: [
          {
            path: ':karteId',
            name: 'karteDetail',
            meta: karteRouteMeta,
            component: KarteListPage,
          },
        ],
      },
      {
        path: 'seminar',
        name: 'seminarList',
        component: SeminarListPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
          breadcrumbs: [{ to: { name: 'seminarList' }, text: 'セミナー' }],
        },
      },
      {
        path: 'line-activation-provider-setting',
        name: 'lineActivationProviderSetting',
        component: LineActivationProviderSettingEditPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
        },
      },
      {
        path: 'delivery',
        name: 'chatMessageSendingJobIndex',
        component: ChatMessageSendingJobIndexPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
        },
      },
      {
        path: 'delivery/new',
        name: 'chatMessageSendingJobNew',
        component: ChatMessageSendingJobNewPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
          breadcrumbs: [
            {
              to: { name: 'chatMessageSendingJobIndex' },
              text: 'LINE メッセージ配信',
            },
          ],
        },
      },
      {
        path: 'delivery/jobs/:jobGuid',
        name: 'chatMessageSendingJobDetail',
        component: ChatMessageSendingJobDetailPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
          breadcrumbs: [
            {
              to: { name: 'chatMessageSendingJobIndex' },
              text: 'LINE メッセージ配信',
            },
          ],
        },
      },
      {
        path: 'line/richmenu',
        component: { render: () => h(RouterView) },
        children: [
          {
            name: 'LineRichMenuIndexPage',
            path: '',
            component: LineRichMenuIndexPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'LineRichMenuNewPage',
            path: 'new',
            component: LineRichMenuNewPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
          {
            name: 'LineRichMenuEditPage',
            path: ':lineRichMenuGUID',
            component: LineRichMenuEditPage,
            meta: {
              requiresAuth: true,
              layout: {
                component: layouts._default,
              },
            },
          },
        ],
      },
      // いちおう新しい設定ページへのリダイレクトを行う
      // 1, 2週間ほど時間が経っていたら消してもらって OK
      // 対応日： 2023年8月23日（水）
      {
        path: 'auto_chat_reply_setting',
        name: 'autoChatReplySettingList',
        redirect: { name: 'autoChatReplySetting' },
      },
      {
        path: 'attack_list_sender_setting_csv',
        name: 'attackListSenderSettingCsv',
        component: AttackListSenderSettingCsvPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
        },
      },
      {
        path: 'kollege',
        name: 'OkaneKollegeIndex',
        component: OkaneKollegeIndexPage,
        meta: {
          requiresAuth: true,
          layout: {
            component: layouts._default,
          },
          breadcrumbs: [
            { to: { name: 'OkaneKollegeIndex' }, text: 'オカネカレッジ' },
          ],
        },
      },
      {
        path: 'kollege/user/:userId',
        name: 'OkaneKollegeUser',
        component: OkaneKollegeUserPage,
        meta: {
          requiresAuth: true,
          layout: { component: layouts._default },
          breadcrumbs: [
            { to: { name: 'OkaneKollegeIndex' }, text: 'オカネカレッジ' },
          ],
        },
        redirect: { name: 'OkaneKollegeEditProfile' },
        children: [
          {
            path: 'trial',
            name: 'OkaneKollegeTrial',
            component: OkaneKollegeUserTrialView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'user-course',
            name: 'OkaneKollegeUserCourse',
            component: OkaneKollegeUserCourseView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'edit-profile',
            name: 'OkaneKollegeEditProfile',
            component: OkaneKollegeUserEditProfileView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'user-course-lesson',
            name: 'OkaneKollegeUserCourseLesson',
            component: OkaneKollegeUserCourseLessonView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'daily-lesson',
            name: 'OkaneKollegeDailyLesson',
            component: OkaneKollegeDailyLessonView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'user-course-cancel',
            name: 'OkaneKollegeUserCourseCancel',
            component: OkaneKollegeUserCourseCancelView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: 'payment',
            name: 'OkaneKollegeUserPayment',
            component: OkaneKollegeUserPaymentView,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: '',
            name: 'OkaneKollegeUserIndex',
            redirect: { name: 'OkaneKollegeEditProfile' },
          },
        ],
      },
    ],
  },
  // 互換性を維持するためのリダイレクト
  {
    path: ROOT_PATH,
    component: EntranceGUIDRedirectPage,
    meta: {
      requiresAuth: true,
      layout: {
        component: layouts.guest,
      },
    },
    children: [
      {
        path: 'enquete/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'scenario-chat/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'stripe_callback/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'skillforce/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'step-delivery/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'settings/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'report/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'news/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'chat/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'karte/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'seminar/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'line-activation-provider-setting/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'delivery/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'line/richmenu/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'attack_list_sender_setting_csv/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'kollege/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
      {
        path: 'auto_chat_reply_setting/:pathMatch(.*)*',
        component: EntranceGUIDRedirectPage,
      },
    ],
  },
  // 認証が不要なページ
  {
    path: '/login',
    name: 'login',
    component: {
      layout: {
        component: layouts.guest,
      },
      render: () => h(LoginPage),
    },
    meta: {
      requiresAuth: false,
    },
    beforeEnter: logoutNavigationGuard,
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      requiresAuth: false,
    },
    redirect: { name: 'login' },
  },
  // settings のレイアウトが不要なので、 /settings/ の外に定義する
  {
    // Microsoft 連携するときの callback 用の path
    // 社内セキュリティで設定しているエンプラ企業もあるので、基本的に変更禁止
    name: 'settingsCalendarAuthCallback',
    path: '/settings/calendar-auth/callback',
    component: SettingsPageCalendarAuthCallbackView,
    meta: {
      layout: {
        component: layouts.guest,
      },
      requiresAuth: false,
    },
  },
  {
    path: '/reset_password',
    component: { render: () => h(RouterView) },
    children: [
      {
        // @deprecated use 'resetPassword'
        path: 'start',
        redirect: { name: 'resetPassword' },
      },
      {
        path: 'request',
        name: 'resetPassword',
        component: PasswordResetRequest,
        meta: {
          requiresAuth: false,
          layout: {
            component: layouts.guest,
          },
        },
      },
      {
        path: 'verify/:token',
        name: 'resetPasswordVerify',
        component: PasswordResetChange,
        meta: {
          requiresAuth: false,
          layout: {
            component: layouts.guest,
          },
        },
      },
    ],
  },
  {
    path: '/terms',
    component: { render: () => h(RouterView) },
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.guest,
      },
    },
    children: [
      {
        path: ':termTypeName',
        name: 'termDetail',
        component: TermPage,
        meta: {
          requiresAuth: false,
          layout: {
            component: layouts.guest,
          },
        },
      },
    ],
  },
  {
    path: '/400',
    name: 'errorBadRequest',
    component: ErrorBadRequest,
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.error,
      },
    },
    beforeEnter: errorPageNavigationGuard(400),
  },
  {
    path: '/404',
    name: 'errorNotFound',
    component: ErrorPageNotFound,
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.error,
      },
    },
    beforeEnter: errorPageNavigationGuard(404),
  },
  {
    path: '/403',
    name: 'errorForbidden',
    component: ErrorPageForbidden,
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.error,
      },
    },
    beforeEnter: errorPageNavigationGuard(403),
  },
  {
    path: '/500',
    name: 'errorInternalServerError',
    component: ErrorPageInternalServerError,
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.error,
      },
    },
    beforeEnter: errorPageNavigationGuard(500),
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPageNotFound,
    meta: {
      requiresAuth: false,
      layout: {
        component: layouts.error,
      },
    },
    beforeEnter: errorPageNavigationGuard(404),
  },
]

const router = createRouter({
  routes: routes as RouteRecordRaw[],
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (
      // カルテ詳細とカルテ一覧の遷移時にはスクロール位置を維持する
      (to.name === 'karteDetail' && from.name === 'karteList') ||
      (to.name === 'karteList' && from.name === 'karteDetail') ||
      (to.name === 'karteDetail' && from.name === 'karteDetail') ||
      // カルテ絞り込み条件を変更したとき、スクロール位置を維持したい
      (to.name === 'karteList' && from.name === 'karteList')
    ) {
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      // https://github.com/vuejs/vue-router/blob/677f3c1f714fb61cc495345e535409b1cbb90429/examples/hash-scroll-behavior/app.js#L47-L49
      return false
    }

    if (to.hash) {
      return { el: to.hash }
    }
    return savedPosition ?? { left: 0, top: 0 }
  },
})

export const isRequireAuthRoute = (route: RouteLocationNormalized): boolean =>
  route.matched.some(
    (record: RouteRecordNormalized) => record.meta?.requiresAuth
  )

export const createLoginRedirectLocation = (
  redirectPath: string,
  redirectQuery: LocationQuery = {}
) => ({
  name: 'login',
  query: {
    path: encodeURIComponent(redirectPath),
    query: encodeURIComponent(JSON.stringify(redirectQuery)),
  } as LocationQueryRaw,
})

//↑
export const createLoginRedirectHref = (
  redirectPath: string,
  redirectQuery: LocationQuery = {}
) =>
  router.resolve(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createLoginRedirectLocation(redirectPath, redirectQuery) as any
  ).fullPath

// NOTE: 上のものと対になるのでここで管理
export const decodeLoginRedirectionLocation = (
  loginPageQuery: LocationQuery
): { path: string; query: LocationQuery } => {
  const queryPath = getQuery(loginPageQuery.path)
  const path =
    queryPath !== undefined ? decodeURIComponent(queryPath) : ROOT_PATH

  const queryQuery = getQuery(loginPageQuery.query)
  const query =
    queryQuery !== undefined
      ? (bindStringDictionary(decodeURIComponent(queryQuery)) ?? {})
      : {}

  return {
    path,
    query,
  }
}

// logging middleware
router.afterEach(async (to, from) => {
  try {
    await store.dispatch('updateSession')
    const referer =
      from.matched.length === 0
        ? document.referrer
        : `${location.protocol}//${location.host}${from.fullPath}`
    const url = new URL(to.fullPath, window.location.origin).toString()
    await logger.ltlPeople.page.view(logger.buildMeta(store, { referer, url }))
  } catch (e) {
    if (!isClientError(e)) {
      captureException(e)
    }
  }
})

router.beforeResolve((_, from, next) => {
  if (from.matched.length > 0) {
    logger.ltlPeople.page.hide(
      logger.buildMeta(store, {
        referer: 'no-referer',
        url: new URL(from.fullPath, window.location.origin).toString(),
      })
    )
  }
  next()
})

window.addEventListener('unload', async () => {
  await logger.ltlPeople.page.hide(
    logger.buildMeta(store, { referer: 'no-referer' })
  )
})

trackRouter(router)

export default router
